// Shared, consent-gated experiment transport. No customer profiles or marketing events.
(() => {
  const website = 'd5af33c6-8de7-4631-925d-54051480ef94';
  window.SBABAnalytics = {
    sendExposure: (metric, properties) => fetch('https://cloud.umami.is/api/send', {
      method: 'POST', headers: {'Content-Type': 'application/json'}, keepalive: true,
      body: JSON.stringify({type: 'event', payload: {
        website, hostname: location.hostname, url: location.pathname,
        language: navigator.language, screen: `${screen.width}x${screen.height}`,
        name: 'ABExposure', data: {...properties, metric},
      }}),
    }),
  };
})();
